__turbopack_context__.v({
  "divider": "r_plKG_divider",
  "thicknessDefault": "r_plKG_thicknessDefault",
  "thicknessThin": "r_plKG_thicknessThin",
});
